import { ALL_MODULES, MODULES } from 'constants/ModuleConstants';

/**
 * @param {import('modules/global/typing/enums/module.enum').ModuleEnum} module
 * @return {string}
 */
export const getClassName = module => MODULES[module]?.icon;

/**
 * @param {import('modules/global/typing/enums/module.enum').ModuleEnum} module
 * @return {string}
 */
const getTranslation = module => {
  const exist = ALL_MODULES.includes(module);
  return exist ? module.toLowerCase() : 'unknown';
};

/**
 * @param {import('modules/global/typing/enums/module.enum').ModuleEnum} module
 * @return {{className: string, translation: string}}
 */
export const getModuleInfo = module => ({
  className: getClassName(module),
  translation: getTranslation(module),
});
